import { useCookies } from 'react-cookie';
import { useFormContext } from 'react-hook-form';

import { useRootSelector } from '../../../../../../store/hooks';
import {
  selectSitePricingProductsData,
  selectSitePricingProductsMeta,
} from '../../../../store/features/products';
import { selectPricingPackagesCount } from '../../../../store/features/packages';
import { VIPCodeFormProps } from '../../../../shared/components/VIPCode/components/VIPCodeForm';
import { PricingPackagesFormValues } from '../../../../store/features/packages/types';
import { useSelectPackageContext } from '../PackageSelectionForm/selectPackageContext';

import { MuiStack } from '../../../../../../modules/material';
import VIPCode from '../../../../shared/components/VIPCode';
import InfoWidgetList from '../../../../shared/components/InfoWidgetList';
import SidebarButtons from '../SidebarButtons';

export interface ProductSelectionRightColumnProps
  extends Pick<VIPCodeFormProps, 'onValidateVipCode'> {}

export default function ProductSelectionRightColumn(
  props: ProductSelectionRightColumnProps,
) {
  const { onValidateVipCode } = props;
  const [cookies] = useCookies(['basket_order']);
  const isBasketOrder = cookies['basket_order'];

  const { setValue } = useFormContext<PricingPackagesFormValues>();
  const { handleChangeSelections } = useSelectPackageContext();
  const packagesCount = useRootSelector(selectPricingPackagesCount);

  const { infoWidgets } = useRootSelector(selectSitePricingProductsData);
  const { appliedCode, promotionCodeApplyResult } = useRootSelector(
    selectSitePricingProductsMeta,
  );

  const handleVIPCodeChange = (vipCode: string) => {
    setValue('vipCode', vipCode);
    return handleChangeSelections();
  };

  return (
    <MuiStack spacing={2} className="informa-payment-select-package-sidebar">
      <VIPCode
        code={appliedCode}
        onValidateVipCode={isBasketOrder ? undefined : onValidateVipCode}
        onCodeChange={isBasketOrder ? handleVIPCodeChange : undefined}
        codeDiscountResult={promotionCodeApplyResult}
      />
      {!!packagesCount && <SidebarButtons />}
      <InfoWidgetList list={infoWidgets.items} variant="withPaper" />
    </MuiStack>
  );
}
